export const ADD_USERDETAIL = "ADD_USERDETAIL";
export const RESET_USERDETAIL = "RESET_USERDETAIL";
export const EDIT_USERDETAIL = "EDIT_USERDETAIL";
export const FETCH_USERDETAIL = "FETCH_USERDETAIL";
